import React from 'react';

const Nosotros = () => {
  return (
    <div className="aboutus">
      <div className="profile-container">
        <h1>Jorge González Honorato</h1>
        <p className="profile-role">
          Ingeniero civil · Desarrollo de software · Gestión de proyectos
        </p>
        <p className="profile-intro">
          Ingeniero civil con más de 7 años de experiencia en banca y finanzas y más de 4 años
          en desarrollo de software. Combina visión comercial y técnica para diseñar
          soluciones que mejoran procesos, integran sistemas y dan visibilidad a los datos.
        </p>

        <section className="profile-section">
          <h2>Trayectoria</h2>
          <ul className="profile-list">
            <li>
              <strong>Development Manager</strong> en B2B Express (transporte y logística).
            </li>
            <li>
              <strong>Software Engineer</strong> en Thovex Software: plataformas empresariales,
              paneles de datos y automatización con React, TypeScript, Node.js, Python,
              PostgreSQL, MongoDB, Firebase, GCP y Railway. Integraciones con Shopify, ERP,
              scraping y APIs de pago.
            </li>
            <li>
              <strong>Co-fundador</strong> de proyectos como zipp.cl y Bioma Coffee Roasters.
            </li>
            <li>
              <strong>Software Developer</strong> en To Studio: diseño web y desarrollo frontend/backend.
            </li>
            <li>
              Experiencia previa en banca mayorista (Itaú Chile, Banco BICE) y análisis de riesgo
              operacional (LarrainVial).
            </li>
          </ul>
        </section>

        <section className="profile-section">
          <h2>Formación y certificaciones</h2>
          <p>
            Ingeniería civil, Industrial — Universidad de los Andes (titulado con máxima distinción).
            Certificaciones y cursos en desarrollo web, blockchain y Python (MIT Professional Education,
            Udemy, Coursera, entre otros).
          </p>
        </section>

        <section className="profile-section">
          <h2>Idiomas</h2>
          <p>Español nativo · Inglés nivel profesional</p>
        </section>

        <p className="profile-linkout">
          <a
            className="lp-btn lp-btn-secondary profile-linkedin"
            href="https://www.linkedin.com/in/cokeghm/"
            rel="noreferrer"
            target="_blank"
          >
            Perfil completo en LinkedIn
          </a>
        </p>
      </div>
    </div>
  );
};

export default Nosotros;
